/* eslint-disable react-hooks/exhaustive-deps */

import { useAuth } from "context/AuthContext";
import { Outlet } from "react-router";
import { UserInfo } from "components/user-info";

import "./styles.scss";

import { NavLink, useSearchParams } from "react-router-dom";
import { NavMenu } from "components/navmenu";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { registerLocale } from "react-datepicker";
import DatePicker from "react-datepicker";
import { getExtratoSimples } from "services/extrato.service";
import "react-datepicker/dist/react-datepicker.css";
import pt from "date-fns/locale/pt-BR";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import "moment/locale/pt-br";
import { RegulamentoFooter } from "components/regulamento-footer";
import { CARDS_CATALOG_IDS, PREMIOS_CATALOG_IDS } from "utils/constants";
import { FaChevronDown } from "react-icons/fa";

moment.locale("pt-br");

const CATALOG_PREFIXES: Record<string, string> = {
  ...prefixesFor(CARDS_CATALOG_IDS, "CARD"),
  ...prefixesFor(PREMIOS_CATALOG_IDS, "PRÊMIO"),
};

function prefixesFor(catalogIds: string[], prefix: string) {
  return Object.fromEntries(catalogIds.map((id) => [id, prefix]));
}

/**
 * Destaca os lançamentos vindos dos catálogos da temporada 2026 com o prefixo
 * do seu tipo, para o empregado identificar a origem do ganho.
 */
function formatItemName(item: any) {
  if (!item?.name) return "";

  const prefix = CATALOG_PREFIXES[item.catalogId];
  return prefix ? `${prefix} ${item.name}` : item.name;
}

/** Acima disso, a descrição aparece cortada e o "ver mais" mostra o resto. */
const DESCRIPTION_PREVIEW_LENGTH = 120;

/** Corta no último espaço antes do limite, para não partir uma palavra. */
function previewDescription(text: string) {
  const cut = text.slice(0, DESCRIPTION_PREVIEW_LENGTH);
  const lastSpace = cut.lastIndexOf(" ");
  return `${(lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd()}…`;
}

/**
 * Nome do item no extrato, com a descrição logo abaixo. Descrições longas
 * aparecem cortadas, e o "ver mais" abre o texto completo.
 */
function ItemDescription({ item }: { item: any }) {
  const [open, setOpen] = useState(false);
  const name = formatItemName(item);
  const description = item?.description?.trim();

  if (!description) return <>{name}</>;

  const isLong = description.length > DESCRIPTION_PREVIEW_LENGTH;
  const text = isLong && !open ? previewDescription(description) : description;

  return (
    <div>
      <span>{name}</span>
      <p className="mt-1 text-sm opacity-80 whitespace-pre-line">
        {text}
        {isLong && (
          <>
            {" "}
            <button
              type="button"
              onClick={() => setOpen((value) => !value)}
              aria-expanded={open}
              className="inline-flex items-center gap-1 text-[#88e1f2] hover:underline whitespace-nowrap"
            >
              {open ? "ver menos" : "ver mais"}
              <FaChevronDown
                aria-hidden="true"
                className={`text-xs transition-transform ${open ? "rotate-180" : ""}`}
              />
            </button>
          </>
        )}
      </p>
    </div>
  );
}

/**
 * A entrega automática do prêmio consome o card e registra a troca em si.
 * Para o empregado, o que importa é o card que ele ganhou e a recompensa que
 * caiu na conta — os dois lançamentos internos da troca só confundem o extrato.
 */
function isLancamentoInternoDeResgate(item: any) {
  const catalogId = item?.item?.catalogId;
  if (!catalogId) return false;

  const cardConsumido =
    CARDS_CATALOG_IDS.includes(catalogId) && Number(item.total) < 0;

  return cardConsumido || PREMIOS_CATALOG_IDS.includes(catalogId);
}

export function Extrato() {
  const { user } = useAuth();
  const [extrato, setExtrato] = useState<any>();
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const { register, handleSubmit, setValue, reset, control } = useForm();
  const [loading, setLoading] = useState<boolean>(false);
  const [extratoPlayer, setExtratoPlayer] = useState<boolean>(true);
  let [searchParams, setSearchParams] = useSearchParams();

  async function loadData(id: any) {
    setLoading(true);
    const data = await getExtratoSimples(
      id,
      startDate ? startDate : "2023-01-01T00:00:00.000Z",
      endDate ? endDate : "NOW"
    );
    setExtrato(data);
    setLoading(false);
  }

  useEffect(() => {
    setLoading(true);
    if (user) {
      // console.log(user.challenges);
      if (searchParams.get("unidade")) {
        setTimeout(() => {
          setExtratoPlayer(false);
          var btn = document.getElementById("extratoUnidade");
          btn?.click();
        }, 500);
      } else {
        loadData(user._id);
      }
    }
  }, [user]);

  useEffect(() => {
    if (endDate) {
      endDate.setHours(20, 59, 59); //ajustar depois
      setEndDate(endDate);
    }
    if (user) {
      extratoPlayer ? loadData(user?._id) : loadData(user?.extra.unidade);
    }
  }, [user, startDate, endDate]);

  registerLocale("pt-BR", pt);

  if (!user) return null;

  return (
    <>
      <Helmet>
        <title>CONTA COMIGO BRB</title>
      </Helmet>
      <div id="home-wrapper" className="min-h-screen">
        <div className="z-10 relative flex flex-col items-center">
          <NavMenu />

          <div className="w-full flex justify-center md:p-0">
            <UserInfo />
          </div>
          <div
            className="w-full md:w-[1200px] p-4 md:p-8 md:flex"
            id="filterExtrato"
          >
            <div className="md:w-[20%]">
              <h2>
                <strong>Extrato</strong>
              </h2>
            </div>
            <div className="md:w-[80%] flex justify-end filterDate">
              <form
                id="search-form-theme-calendar"
                autoComplete="off"
                noValidate
              >
                <div>
                  <Controller
                    name="startTime"
                    control={control}
                    render={() => (
                      <DatePicker
                        placeholderText="Data Inicio"
                        className="input md:mr-2 w-full md:w-auto"
                        locale="pt-BR"
                        dateFormat="dd/MM/yyyy"
                        selected={startDate}
                        onChange={(e: any) => {
                          setStartDate(e);
                          setValue("startTime", new Date(e as Date).getTime());
                        }}
                      />
                    )}
                  />
                </div>
                <div>
                  <Controller
                    name="endTime"
                    control={control}
                    render={() => (
                      <DatePicker
                        placeholderText="Data Fim"
                        className="input md:mr-2 w-full md:w-auto"
                        locale="pt-BR"
                        dateFormat="dd/MM/yyyy"
                        selected={endDate}
                        onChange={(e: any) => {
                          setEndDate(e);
                          setValue("endTime", new Date(e as Date).getTime());
                        }}
                      />
                    )}
                  />
                </div>
                <div className="flex justify-center items-center">
                  <button
                    type="button"
                    onClick={() => {
                      reset();
                      setStartDate("");
                      setEndDate("");
                    }}
                  >
                    Limpar
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="w-full md:w-[1200px] p-4 md:p-8 md:flex filter">
            <button
              id="meuExtrato"
              className={
                "bg-[#6b6b85] text-[#04227C]  p-3 font-bold uppercase" +
                (extratoPlayer ? " active" : "")
              }
              onClick={() => {
                loadData(user._id);
                setExtratoPlayer(true);
              }}
            >
              Meu Extrato
            </button>
            <button
              id="extratoUnidade"
              className={
                "bg-[#6b6b85] text-[#04227C]  p-3 font-bold uppercase ml-2" +
                (extratoPlayer ? "" : " active")
              }
              onClick={() => {
                loadData(user.extra.unidade);
                setExtratoPlayer(false);
              }}
            >
              Extrato Unidade
            </button>
          </div>
          <div className="w-full md:w-[1200px] mb-[100px]" id="extrato">
            {loading ? (
              <p className="text-center loading">Carregando...</p>
            ) : (
              <Scrollbars
                style={{ width: "100%", height: 400 }}
                className="contentExtrato"
                renderTrackVertical={(props) => (
                  <div {...props} className="track-vertical" />
                )}
              >
                <table className="table">
                  <thead>
                    <tr>
                      <th className="w-[120px] rounded-l-md md:rounded-none">
                        DATA
                      </th>
                      <th>QUANTIDADE</th>
                      <th>DESCRIÇÃO</th>
                      <th>DESAFIO</th>
                    </tr>
                  </thead>
                  <tbody>
                    {extrato
                      ?.filter(
                        (item: any) =>
                          item.type !== 1 && !isLancamentoInternoDeResgate(item)
                      )
                      .map((item: any) => (
                        <tr key={item._id}>
                          <td>
                            <span className="hidden md:block">
                              {moment(item.time).format("DD/MM/YYYY HH:mm")}
                            </span>
                            <span className="md:hidden block w-16">
                              {moment(item.time).format("DD/MM YYYY HH:mm")}
                            </span>
                          </td>
                          <td>{!!item.total ? item.total : 0}</td>
                          <td>
                            <ItemDescription item={item.item} />
                          </td>
                          <td>{item.origin.name}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </Scrollbars>
            )}
          </div>
        </div>
        <RegulamentoFooter />
      </div>
      <Outlet />
    </>
  );
}
